import { IconAI } from "components/icons";
import { useMprcTheme } from "components/MprcThemeProvider";
import * as React from "react";
import { MprcIconButton, MprcIconButtonProps } from "../MprcIconButton";

export const IconButtonAI: React.FC<MprcIconButtonProps> = ({ title, ...rest }) => {
    const { theme } = useMprcTheme();
    const lTitle = title || theme.iconButtons.IconButtonAI.title;

    return (
        <MprcIconButton
            {...rest}
            title={lTitle}
        >
            <IconAI fixedWidth  />
        </MprcIconButton>
    );
};
